<app-grafana-embed
  [src]="grafanaUrl"
  [height]="900"
></app-grafana-embed>

